import React from "react"
import styled, {createGlobalStyle} from "styled-components";
import CloseBtn from "../CloseBtn";
import ResponsivePlayer from "./Video";

const GlobalStyle = createGlobalStyle`
  body, html {
    background-color: #000;
  }
`

const VideoMainBlock = styled.div`
  background-color: #000;
  height: 100vh;
  box-sizing: border-box;
  padding: 0 20px;
`

const BannerVideo = ({timer, nextFunc, value, detailHandler}) => {
    const handlerPlayerClick = () => {
        detailHandler()
    }

    return (
        <>
            <GlobalStyle/>
            <VideoMainBlock>
                <CloseBtn count={timer} clearDelay={nextFunc}/>
                <div onClick={handlerPlayerClick}>
                    <div style={{
                        height: "calc(100vh - 60px)",
                        pointerEvents: "none",
                    }}>
                        <ResponsivePlayer value={value}/>
                    </div>
                </div>
            </VideoMainBlock>
        </>
    )
}

export default BannerVideo